// extracted by mini-css-extract-plugin
export default {"box_bottom":"ButtonGroup_box_bottom__icrtT","btn_back":"ButtonGroup_btn_back__dmynO","btn_next":"ButtonGroup_btn_next__g-j7E"};